<div class="question question-bool">
    <h2>{{ question.title }}</h2>
    <h3>{{ question.help }}</h3>

    <app-feedback-bool-answer [previousAnswers]="previousAnswers" [answeredAnswers]="answeredAnswers" [feedback]="feedback" [question]="question" [hasAnsweredQuestion]="hasAnsweredQuestion" (onAnswerChange)="answerChanged($event)" (onNextQuestionClicked)="onNextQuestionClicked($event)"></app-feedback-bool-answer>
</div>
